import { memo } from "react";

import RowRenderer from "./RowRenderer";
import { StyledSubSection, StyledSubSectionTitle } from "./styles";
import type { SubSection, Translator } from "./types";

interface SubSectionRendererProps {
  subSection: SubSection;
  translator: Translator;
}

function SubSectionRenderer({
  subSection,
  translator,
}: Readonly<SubSectionRendererProps>) {
  return (
    <StyledSubSection>
      <StyledSubSectionTitle variant='title3'>{`${translator.with(subSection)}`}</StyledSubSectionTitle>

      {subSection.rows.map((row) => (
        <RowRenderer key={`row-${row.number}`} row={row} />
      ))}
    </StyledSubSection>
  );
}

export default memo(SubSectionRenderer);
